import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AreaDeleteOptionsCardBase } from '../area-delete-options-card-base';

@Component({
    selector: 'fi-area-delete-users-and-units-options-card',
    templateUrl: './area-delete-users-and-units-options-card.component.html',
    styleUrls: ['./area-delete-users-and-units-options-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AreaDeleteUsersAndUnitsOptionsCardComponent extends AreaDeleteOptionsCardBase {
    getItemsToDelete(): any[] {
        return this.areaToDeleteData.ItemsToDeleteByUserUnitRights;
    }
}
